import { Slide } from '@mui/material';
import React, { HTMLAttributes } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useOnScreen } from '../../utils/customHooks';
import { LinearProgressDelayed } from '../linearProgressDelayed';
import { StickyPanel } from './stickyPanel';

const useStyles = makeStyles({ name: 'StickyWrapper' })(theme => ({
	root: {
		display: 'flex',
		flexDirection: 'column'
	},
	paddingWrapper: {
		zIndex: 1,
		left: '0',
		right: '0',
		order: 0,
		top: 0,
		'&.sticky': {
			position: 'sticky'
		},
		'&.fixed': {
			position: 'fixed'
		}
	},
	maxWidthWrapper: {

	},
	linearProgress: {
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		transform: 'translateY(100%)'
	}
}));

export type StickyWrapperClasses = Partial<ReturnType<typeof useStyles>['classes']>;

export type StickyWrapperProps<E extends HTMLElement> = React.PropsWithChildren<HTMLAttributes<HTMLDivElement> & {
	stickyPanelContent: React.ReactNode;
	detailElement: E;
	classes?: StickyWrapperClasses;
	loading?: boolean;
	mode?: 'fixed' | 'sticky';
	hideAfterDetail?: boolean;
}>;

export const StickyWrapper = <E extends HTMLElement>(props: StickyWrapperProps<E>) => {
	const { stickyPanelContent, children, detailElement, classes, loading, mode, hideAfterDetail, className, ...other } = props;
	const [detailVisible, detailPosition] = useOnScreen(detailElement);
	const { classes: styles, cx } = useStyles(undefined, { props: { classes } });

	const hideSticky = detailVisible || (hideAfterDetail && detailPosition === 'aboveTop');

	return (
		<div {...other} className={cx(styles.root, className)}>
			<Slide direction='down' in={!hideSticky}>
				<StickyPanel
					maxMobileWidth
					classes={{
						paddingWrapper: cx(styles.paddingWrapper, mode),
						maxWidthWrapper: styles.maxWidthWrapper
					}}>
					<LinearProgressDelayed
						className={cx(styles.linearProgress)}
						loading={loading} />
					{stickyPanelContent}
				</StickyPanel>
			</Slide>
			{children}
		</div>
	);
};

StickyWrapper.defaultProps = {
	mode: 'fixed',
	hideAfterDetail: false
};
